import { Advertisement } from '../../api/adserver';

const getTopImageUrl = (advert: Advertisement) => {
  let topImageUrl = null;
  if (advert.hero_image) {
    topImageUrl = advert.hero_image.url;
  } else if (advert.carousel_images && advert.carousel_images.length > 0) {
    topImageUrl = advert.carousel_images[0].url;
  }
  return topImageUrl;
};

export { getTopImageUrl };
